import { Role } from '../types';
import logger from './logger';

/**
 * データベースのrole値をUI用Role enumに変換
 */
export const mapDatabaseRoleToEnum = (dbRole: string): Role => {
  const roleMapping: Record<string, Role> = {
    super_admin: Role.SUPER_ADMIN,
    ラクハイ管理者: Role.SUPER_ADMIN,
    admin: Role.ADMIN,
    陸送会社管理者: Role.ADMIN,
    dispatcher: Role.DISPATCHER,
    '配車・営業担当者': Role.DISPATCHER,
    driver: Role.DRIVER,
    陸送員: Role.DRIVER,
    manager: Role.MANAGER,
    マネージャー: Role.MANAGER,
    read_only: Role.READ_ONLY,
    閲覧専用: Role.READ_ONLY,
  };

  const mappedRole = roleMapping[dbRole];
  if (!mappedRole) {
    logger.warn('🔧 AuthContext: Unknown role from localStorage, defaulting to READ_ONLY:', dbRole);
    return Role.READ_ONLY;
  }

  logger.debug('🔧 AuthContext: Role mapping for localStorage:', { dbRole, mappedRole });
  return mappedRole;
};
